import React from "react";
import { DA_BasicLink } from "../../../atoms/BasicLink/BasicLink.component";
import { DA_LinkProps } from "../../../../interfaces/linkProps.interface";

export const _FooterLink = (props: DA_LinkProps & { classname: string }) => {
    const handleCookieRenew = () => {
        // Use Usercentrics UC_UI to show cookie settings
        if (window.UC_UI && typeof window.UC_UI.showFirstLayer === "function") {
            window.UC_UI.showFirstLayer();
        }
    };

    return /CookieConsent.*?renew|Cookiebot.*?renew/.test(props.href) ? (
        <button onClick={handleCookieRenew} className={props.classname}>
            {props.title}
        </button>
    ) : (
        <DA_BasicLink
            href={props?.href || props?.link?.url}
            target={props.target ?? "_self"}
            className={props.classname}
        >
            {props.title}
        </DA_BasicLink>
    );
};
